<template>
  <Badge class="cursor-pointer text-wrap">
    <i v-if="filter.isNegated" class="fas fa-not-equal mr-2" />
    <slot />
    <i class="ml-1 fas fa-times" @click.stop="$emit('remove')" />
  </Badge>
</template>

<script setup lang="ts">
import { type PropType } from "vue";
import Badge from "@/components/badges/BadgeComponent.vue";
import type { ActionFilter, EventFilter } from "../../FilterTypes";

defineProps({
  filter: {
    type: Object as PropType<EventFilter | ActionFilter>,
    required: true,
  },
});
defineEmits(["remove"]);
</script>

<style lang="scss" scoped></style>
